import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.scss";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./msalconfig";


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
 
  
  <MsalProvider instance={msalInstance}>
    <App />
    </MsalProvider>
 ,
);
